import templateUrl from 'emun.order/terms/terms-prompt.htm';
import ServiceBus from 'servicestack/service-bus'
import basicController from 'servicestack/basic.controller.properties'
//import config from 'servicestack/tags/_config'
//import labels from 'servicestack/tags/_labels'
import modals from 'webmodals/modals'
import VendorPicker from 'emun.vendor/picker/vendor-picker'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'

class TermsPromptController {
    constructor(options) {
        const $ctrl = this;
        basicController($ctrl);
        $ctrl.request = options.request || {};
        $ctrl.bus = new ServiceBus();
		$ctrl.title = options.title || ' Payment Term...';
        console.debug($ctrl);
        if (!$ctrl.request.id) $ctrl.new = true;
        else {
            $ctrl.vendors = new AutoQuery({
                url: "QueryVendorTerms.json?TermId=" + $ctrl.request.id,
                autoLoad: true
            });
        }
    }

    submit() {
        const $ctrl = this;
        $ctrl.bus.send(`${!$ctrl.new ? 'Upd' : 'Cre'}atePaymentTerm.json`, $ctrl.request)
            .then(function (response) {
                $ctrl.$close($ctrl.request);
            });
    }

	addVendor() {
		let $ctrl = this;
		$ctrl.vendorIds = [];

		return VendorPicker({
			title: "Select Vendor(s)...",
			subTitle: "",
			applyTagsButtonText: false,
			single: false,
			viewSelections: false
		}).then((result) => {
			$ctrl.bus.send("AddVendorTerms", {
				TermId: $ctrl.request.id,
				VendorIds: result
			}).then(function (response) {
				$ctrl.vendors.load();
			});
		});
	}
	updateVendorTerm(vt) {
		const $ctrl = this;
		$ctrl.bus
			.send("UpdateVendorTerm.json", vt)
			.then(function () {
				return $ctrl.vendors.load(true);
			})
			.catch(

			);
	}
	deleteVendorTerm(vt) {
		const $ctrl = this;
		return modals
			.confirm("Are you sure you want to remove " + vt.vendor.label, "Remove Vendor?")
			.result.then(function () {
				//console.info("delete it");
				$ctrl.bus
					.send("DeleteVendorTerm.json", {
						TermId: $ctrl.request.id,
						VendorId: vt.vendorId
					})
					.then(function () {
						return $ctrl.vendors.load(true);
					})
					.catch(

					);
			});
	}
}

const TermsPrompt = {
    open(options) {
        return modals.open(Object.assign({
            templateUrl,
            resolve: {
                options: () => options
            },
            bindToController: true,
            controller: TermsPromptController,
            controllerAs: '$ctrl'
        }, (options || {}).modal)).result;
    }
};

export default TermsPrompt;